import { useEffect, useRef, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { ShieldCheck, Loader2, AlertTriangle } from "lucide-react";

export default function ReplyToVerify() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("loading"); // loading | ok | error
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const once = useRef(false);

  useEffect(() => {
    if (once.current) return;
    once.current = true;
    if (!token) { setState("error"); setMsg("This confirmation link is missing its token."); return; }
    api.post("/public/reply-to/verify", { token })
      .then(({ data }) => { setEmail(data.email || ""); setState("ok"); })
      .catch((e) => { setMsg(e.response?.data?.detail || "This confirmation link is invalid or has expired."); setState("error"); });
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0b0f14] px-6" data-testid="reply-to-verify-page">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card p-8 text-center space-y-4">
        {state === "loading" && (
          <><Loader2 className="h-10 w-10 mx-auto animate-spin text-primary" /><p className="text-muted-foreground">Confirming your reply-to address…</p></>
        )}
        {state === "ok" && (
          <>
            <div className="h-14 w-14 mx-auto rounded-2xl bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center"><ShieldCheck className="h-7 w-7 text-emerald-400" /></div>
            <h1 className="text-xl font-semibold" data-testid="verify-ok">Reply-to confirmed</h1>
            <p className="text-sm text-muted-foreground">{email ? <><strong className="text-foreground">{email}</strong> is now verified. </>: ""}Replies to your branded emails will land in this inbox.</p>
            <Link to="/account" className="inline-block mt-2 rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground" data-testid="verify-back">Back to your workspace</Link>
          </>
        )}
        {state === "error" && (
          <>
            <div className="h-14 w-14 mx-auto rounded-2xl bg-amber-500/15 border border-amber-500/30 flex items-center justify-center"><AlertTriangle className="h-7 w-7 text-amber-400" /></div>
            <h1 className="text-xl font-semibold" data-testid="verify-error">Couldn't confirm this link</h1>
            <p className="text-sm text-muted-foreground">{msg}</p>
            <Link to="/account" className="inline-block mt-2 rounded-lg border border-border px-4 py-2 text-sm font-semibold" data-testid="verify-back">Go to your workspace</Link>
          </>
        )}
      </div>
    </div>
  );
}
